import angular from 'angular';

import { InsuranceComponent } from './insurance.component';

angular.module('app.tools.insurance', []).component('insurance', InsuranceComponent);
